export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// localStorage
export const AUTH_TOKEN_KEY = 'application_token';
export const EMAIL_KEY = 'email';

export const PERSONA_SCRIPT =
  'https://cdn.withpersona.com/dist/persona-v4.2.0.js';
